const screwData = [
  {
    Screw: '#0-80 UNF',
    'Dia (mm)': 1.52,
    'Dia (in)': 0.06,
    'Pitch (mm)': 0.32,
    TPI: 80,
    'Tap Drill': '3/64',
  },
  {
    Screw: 'M1.6X0.35',
    'Dia (mm)': 1.6,
    'Dia (in)': 0.063,
    'Pitch (mm)': 0.35,
    TPI: 73,
    'Tap Drill': '1.25mm',
  },
  {
    Screw: '#1-72 UNF',
    'Dia (mm)': 1.85,
    'Dia (in)': 0.073,
    'Pitch (mm)': 0.35,
    TPI: 72,
    'Tap Drill': '53',
  },
  {
    Screw: '#1-64 UNC',
    'Dia (mm)': 1.85,
    'Dia (in)': 0.073,
    'Pitch (mm)': 0.4,
    TPI: 64,
    'Tap Drill': '53',
  },
  {
    Screw: 'M2X0.4',
    'Dia (mm)': 2.0,
    'Dia (in)': 0.0787,
    'Pitch (mm)': 0.4,
    TPI: 64,
    'Tap Drill': '1.6mm',
  },
  {
    Screw: '#2-64 UNF',
    'Dia (mm)': 2.18,
    'Dia (in)': 0.086,
    'Pitch (mm)': 0.4,
    TPI: 64,
    'Tap Drill': '50',
  },
  {
    Screw: '#2-56 UNC',
    'Dia (mm)': 2.18,
    'Dia (in)': 0.086,
    'Pitch (mm)': 0.45,
    TPI: 56,
    'Tap Drill': '50',
  },
  {
    Screw: 'M2.5X0.45',
    'Dia (mm)': 2.5,
    'Dia (in)': 0.0984,
    'Pitch (mm)': 0.45,
    TPI: 56,
    'Tap Drill': '2.05mm',
  },
  {
    Screw: '#3-56 UNF',
    'Dia (mm)': 2.51,
    'Dia (in)': 0.099,
    'Pitch (mm)': 0.45,
    TPI: 56,
    'Tap Drill': '45',
  },
  {
    Screw: '#3-48 UNC',
    'Dia (mm)': 2.51,
    'Dia (in)': 0.099,
    'Pitch (mm)': 0.53,
    TPI: 48,
    'Tap Drill': '47',
  },
  {
    Screw: '#4-48 UNF',
    'Dia (mm)': 2.84,
    'Dia (in)': 0.112,
    'Pitch (mm)': 0.53,
    TPI: 48,
    'Tap Drill': '42',
  },
  {
    Screw: '#4-40 UNC',
    'Dia (mm)': 2.84,
    'Dia (in)': 0.112,
    'Pitch (mm)': 0.64,
    TPI: 40,
    'Tap Drill': '43',
  },
  {
    Screw: 'M3X0.5',
    'Dia (mm)': 3.0,
    'Dia (in)': 0.1181,
    'Pitch (mm)': 0.5,
    TPI: 51,
    'Tap Drill': '2.5mm',
  },
  {
    Screw: '#5-44 UNF',
    'Dia (mm)': 3.18,
    'Dia (in)': 0.125,
    'Pitch (mm)': 0.58,
    TPI: 44,
    'Tap Drill': '37',
  },
  {
    Screw: '#5-40 UNC',
    'Dia (mm)': 3.18,
    'Dia (in)': 0.125,
    'Pitch (mm)': 0.64,
    TPI: 40,
    'Tap Drill': '38',
  },
  {
    Screw: 'M3.5X0.6',
    'Dia (mm)': 3.5,
    'Dia (in)': 0.1378,
    'Pitch (mm)': 0.6,
    TPI: 42,
    'Tap Drill': '2.9mm',
  },
  {
    Screw: '#6-40 UNF',
    'Dia (mm)': 3.51,
    'Dia (in)': 0.138,
    'Pitch (mm)': 0.64,
    TPI: 40,
    'Tap Drill': '33',
  },
  {
    Screw: '#6-32 UNC',
    'Dia (mm)': 3.51,
    'Dia (in)': 0.138,
    'Pitch (mm)': 0.79,
    TPI: 32,
    'Tap Drill': '36',
  },
  {
    Screw: 'M4X0.7',
    'Dia (mm)': 4.0,
    'Dia (in)': 0.1575,
    'Pitch (mm)': 0.7,
    TPI: 36,
    'Tap Drill': '3.3mm',
  },
  {
    Screw: '#8-36 UNF',
    'Dia (mm)': 4.17,
    'Dia (in)': 0.164,
    'Pitch (mm)': 0.71,
    TPI: 36,
    'Tap Drill': '29',
  },
  {
    Screw: '#8-32 UNC',
    'Dia (mm)': 4.17,
    'Dia (in)': 0.164,
    'Pitch (mm)': 0.79,
    TPI: 32,
    'Tap Drill': '29',
  },
  {
    Screw: '#10-32 UNF',
    'Dia (mm)': 4.83,
    'Dia (in)': 0.19,
    'Pitch (mm)': 0.79,
    TPI: 32,
    'Tap Drill': '21',
  },
  {
    Screw: '#10-24 UNC',
    'Dia (mm)': 4.83,
    'Dia (in)': 0.19,
    'Pitch (mm)': 1.06,
    TPI: 24,
    'Tap Drill': '25',
  },
  {
    Screw: 'M5X0.8',
    'Dia (mm)': 5.0,
    'Dia (in)': 0.1969,
    'Pitch (mm)': 0.8,
    TPI: 32,
    'Tap Drill': '4.2mm',
  },
  {
    Screw: '#12-28 UNF',
    'Dia (mm)': 5.49,
    'Dia (in)': 0.216,
    'Pitch (mm)': 0.91,
    TPI: 28,
    'Tap Drill': '14',
  },
  {
    Screw: '#12-24 UNC',
    'Dia (mm)': 5.49,
    'Dia (in)': 0.216,
    'Pitch (mm)': 1.06,
    TPI: 24,
    'Tap Drill': '16',
  },
  {
    Screw: 'M6X0.75',
    'Dia (mm)': 6.0,
    'Dia (in)': 0.2362,
    'Pitch (mm)': 0.75,
    TPI: 34,
    'Tap Drill': '5.25mm',
  },
  {
    Screw: 'M6X1',
    'Dia (mm)': 6.0,
    'Dia (in)': 0.2362,
    'Pitch (mm)': 1.0,
    TPI: 25,
    'Tap Drill': '5mm',
  },
  {
    Screw: '1/4-28 UNF',
    'Dia (mm)': 6.35,
    'Dia (in)': 0.25,
    'Pitch (mm)': 0.91,
    TPI: 28,
    'Tap Drill': '3',
  },
  {
    Screw: '1/4-20 UNC',
    'Dia (mm)': 6.35,
    'Dia (in)': 0.25,
    'Pitch (mm)': 1.27,
    TPI: 20,
    'Tap Drill': '7',
  },
  {
    Screw: '5/16-24 UNF',
    'Dia (mm)': 7.94,
    'Dia (in)': 0.3125,
    'Pitch (mm)': 1.06,
    TPI: 24,
    'Tap Drill': 'I',
  },
  {
    Screw: '5/16-18 UNC',
    'Dia (mm)': 7.94,
    'Dia (in)': 0.3125,
    'Pitch (mm)': 1.41,
    TPI: 18,
    'Tap Drill': 'F',
  },
  {
    Screw: 'M8X1',
    'Dia (mm)': 8.0,
    'Dia (in)': 0.315,
    'Pitch (mm)': 1.0,
    TPI: 25,
    'Tap Drill': '7mm',
  },
  {
    Screw: 'M8X1.25',
    'Dia (mm)': 8.0,
    'Dia (in)': 0.315,
    'Pitch (mm)': 1.25,
    TPI: 20,
    'Tap Drill': '6.8mm',
  },
  {
    Screw: '3/8-24 UNF',
    'Dia (mm)': 9.53,
    'Dia (in)': 0.375,
    'Pitch (mm)': 1.06,
    TPI: 24,
    'Tap Drill': 'Q',
  },
  {
    Screw: '3/8-16 UNC',
    'Dia (mm)': 9.53,
    'Dia (in)': 0.375,
    'Pitch (mm)': 1.59,
    TPI: 16,
    'Tap Drill': '5/16',
  },
  {
    Screw: 'M10X1.25',
    'Dia (mm)': 10.0,
    'Dia (in)': 0.3937,
    'Pitch (mm)': 1.25,
    TPI: 20,
    'Tap Drill': '8.8mm',
  },
  {
    Screw: 'M10X1.5',
    'Dia (mm)': 10.0,
    'Dia (in)': 0.3937,
    'Pitch (mm)': 1.5,
    TPI: 17,
    'Tap Drill': '8.5mm',
  },
  {
    Screw: '7/16-20 UNF',
    'Dia (mm)': 11.11,
    'Dia (in)': 0.4375,
    'Pitch (mm)': 1.27,
    TPI: 20,
    'Tap Drill': '25/64',
  },
  {
    Screw: '7/16-14 UNC',
    'Dia (mm)': 11.11,
    'Dia (in)': 0.4375,
    'Pitch (mm)': 1.81,
    TPI: 14,
    'Tap Drill': 'U',
  },
  {
    Screw: 'M12X1.25',
    'Dia (mm)': 12.0,
    'Dia (in)': 0.4724,
    'Pitch (mm)': 1.25,
    TPI: 20,
    'Tap Drill': '10.8mm',
  },
  {
    Screw: 'M12X1.75',
    'Dia (mm)': 12.0,
    'Dia (in)': 0.4724,
    'Pitch (mm)': 1.75,
    TPI: 15,
    'Tap Drill': '10.2mm',
  },
  {
    Screw: '1/2-20 UNF',
    'Dia (mm)': 12.7,
    'Dia (in)': 0.5,
    'Pitch (mm)': 1.27,
    TPI: 20,
    'Tap Drill': '29/64',
  },
  {
    Screw: '1/2-13 UNC',
    'Dia (mm)': 12.7,
    'Dia (in)': 0.5,
    'Pitch (mm)': 1.95,
    TPI: 13,
    'Tap Drill': '27/64',
  },
  {
    Screw: 'M14X1.5',
    'Dia (mm)': 14.0,
    'Dia (in)': 0.5512,
    'Pitch (mm)': 1.5,
    TPI: 17,
    'Tap Drill': '12.5mm',
  },
  {
    Screw: 'M14X2',
    'Dia (mm)': 14.0,
    'Dia (in)': 0.5512,
    'Pitch (mm)': 2.0,
    TPI: 13,
    'Tap Drill': '12mm',
  },
  {
    Screw: '5/8-18 UNF',
    'Dia (mm)': 15.88,
    'Dia (in)': 0.625,
    'Pitch (mm)': 1.41,
    TPI: 18,
    'Tap Drill': '37/64',
  },
  {
    Screw: '5/8-11 UNC',
    'Dia (mm)': 15.88,
    'Dia (in)': 0.625,
    'Pitch (mm)': 2.31,
    TPI: 11,
    'Tap Drill': '17/32',
  },
  {
    Screw: 'M16X1.5',
    'Dia (mm)': 16.0,
    'Dia (in)': 0.6299,
    'Pitch (mm)': 1.5,
    TPI: 17,
    'Tap Drill': '14.5mm',
  },
  {
    Screw: 'M16X2',
    'Dia (mm)': 16.0,
    'Dia (in)': 0.6299,
    'Pitch (mm)': 2.0,
    TPI: 13,
    'Tap Drill': '14mm',
  },
  {
    Screw: '3/4-16 UNF',
    'Dia (mm)': 19.05,
    'Dia (in)': 0.75,
    'Pitch (mm)': 1.59,
    TPI: 16,
    'Tap Drill': '11/16',
  },
  {
    Screw: '3/4-10 UNC',
    'Dia (mm)': 19.05,
    'Dia (in)': 0.75,
    'Pitch (mm)': 2.54,
    TPI: 10,
    'Tap Drill': '21/32',
  },
  {
    Screw: 'M20X1.5',
    'Dia (mm)': 20.0,
    'Dia (in)': 0.7874,
    'Pitch (mm)': 1.5,
    TPI: 17,
    'Tap Drill': '18.5mm',
  },
  {
    Screw: 'M20X2.5',
    'Dia (mm)': 20.0,
    'Dia (in)': 0.7874,
    'Pitch (mm)': 2.5,
    TPI: 10,
    'Tap Drill': '17.5mm',
  },
  {
    Screw: '7/8-14 UNF',
    'Dia (mm)': 22.23,
    'Dia (in)': 0.875,
    'Pitch (mm)': 1.81,
    TPI: 14,
    'Tap Drill': '13/16',
  },
  {
    Screw: '7/8-9 UNC',
    'Dia (mm)': 22.23,
    'Dia (in)': 0.875,
    'Pitch (mm)': 2.82,
    TPI: 9,
    'Tap Drill': '49/64',
  },
  {
    Screw: 'M24X2',
    'Dia (mm)': 24.0,
    'Dia (in)': 0.9449,
    'Pitch (mm)': 2.0,
    TPI: 13,
    'Tap Drill': '20mm',
  },
  {
    Screw: 'M24X3',
    'Dia (mm)': 24.0,
    'Dia (in)': 0.9449,
    'Pitch (mm)': 3.0,
    TPI: 8,
    'Tap Drill': '21mm',
  },
  {
    Screw: '1-12 UNF',
    'Dia (mm)': 25.4,
    'Dia (in)': 1.0,
    'Pitch (mm)': 2.12,
    TPI: 12,
    'Tap Drill': '59/64',
  },
  {
    Screw: '1-8 UNC',
    'Dia (mm)': 25.4,
    'Dia (in)': 1.0,
    'Pitch (mm)': 3.18,
    TPI: 8,
    'Tap Drill': '7/8',
  },
];

export default screwData;
